<ng-template class="modal-dialog" #exportCSV>
  <div class="loader" *ngIf="loading"></div>
  <div class="modal-container">
  <div class="email-text">{{ 'store.export.title' | translate }}</div>
  <div class="message-text">{{ 'store.export.message' | translate }}</div>
  <input  #einput required [(ngModel)]="email" [placeholder]="'store.export.placeholder' | translate" type="email"
         pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" >
  <div>
    <a class="Controls__BackLink"
       (click)="close()">
      <i class="fas fa-chevron-left"></i>
      {{ 'common.back' | translate }}
    </a>
    <button [ngClass]="{'disabled-btn': !einput.validity.valid}" [disabled]="!einput.validity.valid" (click)="sendCSV()">{{ 'common.send' | translate }}</button>
  </div>
</div>
</ng-template>
